import { createFileRoute } from '@tanstack/react-router';
import { rulesQuery } from '@/features/rules/api';
import { RulesPage } from '@/features/rules/pages/RulesPage';
import { sourcesQuery } from '@/features/sources/api';

export const Route = createFileRoute('/_authed/ops/rules/')({
  staticData: { help: 'trust-rules' },
  loader: ({ context: { queryClient } }) => {
    void queryClient.prefetchQuery(rulesQuery());
    void queryClient.prefetchQuery(sourcesQuery());
  },
  component: RulesPage,
});
